module.exports = __webpack_public_path__ + "static/media/slide-3.6533ad2b.jpg";